<template>
	<div id="login-wrapper">
		<div class="auth-box-w" :class="(blurred) ? 'blurred' : ''">
			<div class="logo-w">
				<a href="index.html"><img alt="" src="img/logo-big.png"></a>
			</div>
			<h4 class="auth-header">
				{{ t.login }}
			</h4>
			<div class="px-3">
				<div class="alert alert-warning" v-show="loginError">
					{{ t.auth.login_error }}
				</div>
			</div>
			<form v-on:submit.prevent="login">
				<div class="form-group">
					<label for="">{{ t.user.username }}</label><input v-model="username" class="form-control" placeholder="Enter your username" type="text">
					<div class="pre-icon os-icon os-icon-user-male-circle"></div>
				</div>
				<div class="form-group">
					<label for="">{{ t.user.password }}</label><input v-model="password" class="form-control" placeholder="Enter your password" type="password">
					<div class="pre-icon os-icon os-icon-fingerprint"></div>
				</div>
				<div class="buttons-w">
					<button class="btn btn-primary">Log me in</button>
					<div class="form-check-inline">
						<label class="form-check-label"><input class="form-check-input" type="checkbox">Remember Me</label>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
    export default {
        name: 'login',
	    props: {

	    },
        data () {
            return {
                t: this.$root.t,
                username: null,
	            password: null,
                loginError: false,
	            blurred: true,
                clientId: null,
                clientSecret: null
            }
        },
	    mounted () {

            this.isLogged();
	    },
	    methods: {
            isLogged () {
                this.refreshToken = this.$cookie.get('refresh_token');

                if (this.refreshToken && this.clientId && this.clientSecret) {
                    this.$http.get(api+'oauth/v2/token',
                        {params:  {client_id: this.clientId, client_secret: this.clientSecret,grant_type: 'refresh_token',
                            refresh_token: this.refreshToken } } ).then(
                        response => {
                            this.$emit('accessToken', {cl: this.clientId, cs: this.clientSecret, at: response.body.access_token, rt:response.body.refresh_token });
                            this.$cookie.set('refresh_token', response.body.refresh_token, 1);
                            window.accessTokenHeader = response.body.access_token;

                        }, response => {
                            this.$cookie.delete('refresh_token');
                            //this.$cookie.delete('client_id');
                            //this.$cookie.delete('client_secret');
                            this.blurred = false;
                        });
                }else {
                    this.blurred = false;
                }
            },
            login () {

                if (this.password && this.username) {
                    this.loginError = false;
                    this.blurred = true;
                    this.$bus.$emit('globalLoader', 0);

                    if(typeof window.auth.client === 'undefined')
                        this.getClient();

                    this.clientId = window.auth.client;
                    this.clientSecret = window.auth.clientSecret;

                    this.$http.get(api+'oauth/v2/token',
                        {params:  {client_id: this.clientId, client_secret: this.clientSecret,grant_type: 'password',
                                username: this.username, password: this.password } } ).then(
                        response => {
                        this.$emit('accessToken', {at: response.body.access_token, rt:response.body.refresh_token });
                    window.accessTokenHeader = response.body.access_token;

                    window.auth.accessToken = response.body.access_token;
                    window.auth.refreshToken = response.body.refresh_token;

                    this.$setItem('auth', window.auth);
                    this.blurred = false;

                    window.location.reload();
                }, response => {
                        this.loginError = true;
                        this.blurred = false;

                        this.$notify({
                            group: 'app',
                            title: this.t.processing.error,
                            text: this.t.auth.login_error,
                            type: 'error',
                        });
                        this.$bus.$emit('globalLoader', 0);

                    });
                    return false;
                }
            },
            getClient () {

                this.accessToken = window.auth.accessToken;

                if (!this.accessToken) {
                    this.$http.get(api+'api/v1/get/client').then(response => {
                        // get body data
                        this.clientId = response.body.client_id;
                        this.clientSecret = response.body.client_secret;

	                    window.auth.client = response.body.client_id;
	                    window.auth.clientSecret = response.body.client_secret;

                }, response => {
                        // error callback
                        //this.$cookie.delete('client_id');
                        //this.$cookie.delete('client_secret');
                    });
                }
            },
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	#login-wrapper {
		padding: 50px
	}
	.auth-box-w {

	}
</style>



// WEBPACK FOOTER //
// src/components/auth/Login.vue